var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"container"},[_c('nav'),_c('div',{staticClass:"copyright text-center"},[_vm._v(" © "+_vm._s(new Date().getFullYear())+" "),_c('a',{attrs:{"href":"https://friss.com","target":"_blank"}},[_vm._v("FRISS")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }